export default __webpack_public_path__ + "static/media/Background_00130.496bf4ac.png";